/* Blindbox: manual currency estimate (display only).
   SEK stays the real price and the checkout currency.
   The visitor picks DKK / NOK / EUR in a small strip at the top; an approximate amount
   is shown next to each price. Never switches automatically by location. */
(function () {
  'use strict';

  var CURRENCIES = ['SEK', 'DKK', 'NOK', 'EUR'];
  // Fallback rates (1 SEK = x) used only if the live rate cannot be loaded.
  var FALLBACK = { DKK: 0.67, NOK: 0.95, EUR: 0.09 };
  var RATE_KEY = 'bb_fx_rates_v1';
  var CUR_KEY = 'bb_fx_currency';
  var RATE_TTL = 24 * 60 * 60 * 1000;
  var RATE_URL = 'https://api.frankfurter.dev/v1/latest?base=SEK&symbols=DKK,NOK,EUR';

  var lang = (document.documentElement.lang || 'sv').slice(0, 2);
  var T = lang === 'sv'
    ? { label: 'Visa uppskattat pris i', note: 'Priser och betalning i SEK. Belopp i annan valuta är en uppskattning.', cartNote: 'Betalning sker i SEK. Beloppet i annan valuta är en uppskattning.' }
    : { label: 'Show estimated price in', note: 'Prices and payment are in SEK. Other currencies are estimates.', cartNote: 'Payment is in SEK. Amounts in other currencies are estimates.' };

  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  var currency = get(CUR_KEY);
  if (CURRENCIES.indexOf(currency) === -1) currency = 'SEK';
  var rates = FALLBACK;

  function loadRates(done) {
    var cached = null;
    try { cached = JSON.parse(get(RATE_KEY) || 'null'); } catch (e) {}
    if (cached && cached.rates && Date.now() - cached.t < RATE_TTL) { rates = cached.rates; return done(); }
    if (cached && cached.rates) rates = cached.rates; // stale is better than fallback
    if (currency === 'SEK') return done(); // no need to fetch until the visitor opts in
    fetch(RATE_URL).then(function (r) { return r.json(); }).then(function (j) {
      if (j && j.rates && j.rates.DKK && j.rates.NOK && j.rates.EUR) {
        rates = { DKK: j.rates.DKK, NOK: j.rates.NOK, EUR: j.rates.EUR };
        set(RATE_KEY, JSON.stringify({ t: Date.now(), rates: rates }));
      }
      done();
    }).catch(function () { done(); });
  }

  function fmt(sek) {
    var v = sek * rates[currency];
    if (currency === 'EUR') return '≈ ' + (Math.round(v * 100) / 100).toFixed(2).replace('.', ',') + ' EUR';
    return '≈ ' + Math.round(v).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' ' + currency;
  }

  function sekFrom(text) {
    var m = String(text).replace(/ /g, ' ').match(/(\d[\d\s.,]*)\s*(?:kr|SEK)\b/i);
    if (!m) return null;
    var digits = m[1].replace(/[^\d]/g, '');
    return digits ? parseInt(digits, 10) : null;
  }

  function addStyle() {
    var s = document.createElement('style');
    s.textContent =
      '.bb-fx-bar{display:flex;flex-wrap:wrap;gap:.25rem 1rem;align-items:center;justify-content:flex-end;padding:.35rem 1rem;font-size:12px;line-height:1.4;background:#f6f6f6;color:#444}' +
      '.bb-fx-bar button{all:unset;cursor:pointer;padding:.1rem .45rem;border-radius:3px;text-transform:none!important}' +
      '.bb-fx-bar button[aria-pressed=true]{background:#111;color:#fff}' +
      '.bb-fx-bar button:focus-visible{outline:2px solid #111;outline-offset:1px}' +
      '.bb-fx-note{margin-right:auto;opacity:.8}' +
      '.bb-fx-est{display:block;font-size:.8em;opacity:.7;font-weight:400;white-space:nowrap}' +
      '.bb-fx-est--tot{text-align:right;margin:.15rem 0 .5rem}' +
      '.bb-fx-cartnote{font-size:12px;opacity:.75;margin:.5rem 0}' +
      'html.bb-fx-on free-shipping-goal,html.bb-fx-on .free-shipping-goal{display:none!important}' +
      '@media (max-width:600px){.bb-fx-bar{justify-content:center;padding:.3rem .5rem}.bb-fx-lab{display:none}.bb-fx-note{flex-basis:100%;order:2;margin:0;text-align:center;font-size:11px}}';
    document.head.appendChild(s);
  }

  function buildBar() {
    if (document.querySelector('.bb-fx-bar')) return;
    var bar = document.createElement('div');
    bar.className = 'bb-fx-bar';
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', T.label);
    var note = document.createElement('span');
    note.className = 'bb-fx-note';
    bar.appendChild(note);
    var lab = document.createElement('span');
    lab.className = 'bb-fx-lab';
    lab.textContent = T.label;
    bar.appendChild(lab);
    CURRENCIES.forEach(function (c) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = c;
      b.setAttribute('data-cur', c);
      b.addEventListener('click', function () { choose(c); });
      bar.appendChild(b);
    });
    var wrap = document.querySelector('.site-wrapper') || document.body;
    wrap.insertBefore(bar, wrap.firstChild);
    refreshBar();
  }

  function refreshBar() {
    var bar = document.querySelector('.bb-fx-bar');
    if (!bar) return;
    bar.querySelectorAll('button').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-cur') === currency ? 'true' : 'false');
    });
    bar.querySelector('.bb-fx-note').textContent = currency === 'SEK' ? '' : T.note;
  }

  function choose(c) {
    currency = c;
    set(CUR_KEY, c);
    refreshBar();
    if (c === 'SEK') { apply(); return; }
    loadRates(apply);
  }

  function apply() {
    // Free shipping (3 000 kr) is Sweden only: hide the cart goal bar when a non-SEK currency is picked.
    document.documentElement.classList.toggle('bb-fx-on', currency !== 'SEK');
    document.querySelectorAll('.bb-fx-est').forEach(function (e) { e.remove(); });
    document.querySelectorAll('[data-bb-fx]').forEach(function (e) { e.removeAttribute('data-bb-fx'); });
    document.querySelectorAll('.bb-fx-cartnote').forEach(function (e) { e.remove(); });
    if (currency === 'SEK') return;
    scan();
  }

  function scan() {
    if (currency === 'SEK') return;
    var items = document.querySelectorAll('.f-price-item, .cart-item__prices .price, .cart-item__total span, .totals__subtotal-value');
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      if (el.closest('.f-price__unit, .unit-price')) continue;
      if (el.classList.contains('f-price-item') === false && el.querySelector('.f-price-item')) continue;
      var sek = sekFrom(el.textContent);
      if (sek === null) continue;
      if (el.getAttribute('data-bb-fx') === String(sek)) continue;
      var isTot = el.classList.contains('totals__subtotal-value');
      var anchor = isTot ? (el.closest('.totals') || el) : el;
      var old = anchor.nextElementSibling;
      if (old && old.classList.contains('bb-fx-est')) old.remove();
      var span = document.createElement('span');
      span.className = 'bb-fx-est' + (isTot ? ' bb-fx-est--tot' : '');
      span.textContent = fmt(sek);
      anchor.insertAdjacentElement('afterend', span);
      el.setAttribute('data-bb-fx', String(sek));
    }
    var checkout = document.querySelectorAll('[name="checkout"]');
    checkout.forEach(function (btn) {
      var host = btn.parentElement;
      if (host && !host.querySelector('.bb-fx-cartnote')) {
        var n = document.createElement('div');
        n.className = 'bb-fx-cartnote';
        n.textContent = T.cartNote;
        btn.insertAdjacentElement('beforebegin', n);
      }
    });
  }

  var timer = null;
  function schedule() {
    if (currency === 'SEK') return;
    clearTimeout(timer);
    timer = setTimeout(scan, 150);
  }

  function init() {
    addStyle();
    document.documentElement.classList.toggle('bb-fx-on', currency !== 'SEK');
    buildBar();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t && t.closest && t.closest('.bb-fx-bar')) continue;
        schedule();
        return;
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    if (currency !== 'SEK') loadRates(apply);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
